import * as authFire from '../../Login/actions/auth-fire-service'

export const emailSignUp = (email, password, chatToken) => (dispatch, getState) => {

  return Promise.resolve(dispatch({
    type: "emailSignUp",
    signUp: {
      email,
      password,
      chatToken
    }
  }))

    .then((signInAction) => {

      return authFire.emailSignUp(email, password, dispatch, chatToken)

    })

}

export const initFacebookSignUp = (email, password, chatToken) => (dispatch, getState) => {

  return dispatch({
    type: "initFacebookSignUp",
    chatToken
  })

}


// WEBPACK FOOTER //
// ./src/Components/SignUp/actions/index.js